import { CalendarDate } from "@/components/Calendar";
import {
  equipmentData,
  mapAnomalyCountData,
  mapBillingData,
  mapCarbonEmission,
  mapCompareData,
  mapCompareTotalEnergyData,
  mapCompareVariableData,
  mapCost,
  mapDailyData,
  mapLoadTypeData,
  mapLoadTypeDayConsumptionMaxPowerCostData,
  mapLoadTypeDayCostData,
  mapMaxPower,
  mapQuarterHourly,
  mapQuarterMaxPower,
  mapRangeData,
  mapToe,
  mapTotalEnergy,
  mapYearCostTotalEnergy,
  targetData,
} from "../utils/dataProcessing";
import { useCertificationQuery } from "./useCertificationQuery";
import { useDailyHourQuery } from "./useDailyHourQuery";
import { useMonthlyQuery } from "./useMonthlyQuery";
import { useYearlyQuery } from "./useYearlyQuery";

export interface ProcessQueryEnabeld {
  dailyTrioEnabled?: boolean;
  dailyTrioLoadTypeEnabled?: boolean;
  hourlyEnabled?: boolean;
  hourlyLoadTypeEnabled?: boolean;
  dailySingleLoadTypeEnabled?: boolean;
  dailyTimeLoadTypeEnabled?: boolean;
  dailyEnabled?: boolean;
  monthlyTrioEnabled?: boolean;
  monthlyTrioLoadTypeEnabled?: boolean;
  monthlySingleEnabled?: boolean;
  monthlyEnabled?: boolean;
  previousMonthlyEnabled?: boolean;
  yearlyTrioEnabled?: boolean;
  yearlyTrioLoadTypeEnabled?: boolean;
  yearlyPairEnabled?: boolean;
  yearLoadTypeEnabled?: boolean;
  fifteenMinuteEnabled?: boolean;
  dailyPairEnabled?: boolean;
  monthlyPairEnabled?: boolean;
  dailySingleEnabled?: boolean;
  yearSingleEnabled?: boolean;
  usageAgaunstEnabled?: boolean;
  monthlyEquipmentEnabled?: boolean;
  monthlyBillingEnabled?: boolean;
  compareTariffEnabled?: boolean;
  compareTotalEnabled?: boolean;
  compareMaxPowerEnabled?: boolean;
  predictionAccuracyEnabled?: boolean;
  certificationEnabled?: boolean;
  dailySourceEnabled?: boolean;
  threeMonthPairSourceEnabled?: boolean;
  statisticsEnabled?: boolean;
  anomalyCountEnabled?: boolean;
  peakReductionRateEnabled?: boolean;
}

export interface QueryProps {
  options?: ProcessQueryEnabeld;
  selectedDate?: CalendarDate;
  equipment?: string;
  planName?: string;
  selectedMonth?: CalendarDate;
}

export const useProcessedQuery = (
  options?: ProcessQueryEnabeld,
  selectedDate?: CalendarDate,
  equipment?: string | null,
  planName?: string | null,
  selectedMonth?: CalendarDate,
) => {
  const {
    dailyTrioEnabled = false,
    dailyTrioLoadTypeEnabled = false,
    hourlyEnabled = false,
    hourlyLoadTypeEnabled = false,
    dailySingleLoadTypeEnabled = false,
    dailyTimeLoadTypeEnabled = false,
    dailyEnabled = false,
    monthlyTrioEnabled = false,
    monthlyTrioLoadTypeEnabled = false,
    monthlySingleEnabled = false,
    monthlyEnabled = false,
    previousMonthlyEnabled = false,
    yearlyTrioEnabled = false,
    yearlyTrioLoadTypeEnabled = false,
    yearlyPairEnabled = false,
    yearLoadTypeEnabled = false,
    fifteenMinuteEnabled = false,
    dailyPairEnabled = false,
    monthlyPairEnabled = false,
    dailySingleEnabled = false,
    yearSingleEnabled = false,
    usageAgaunstEnabled = false,
    monthlyEquipmentEnabled = false,
    monthlyBillingEnabled = false,
    compareTariffEnabled = false,
    compareTotalEnabled = false,
    compareMaxPowerEnabled = false,
    predictionAccuracyEnabled = false,
    certificationEnabled = false,
    dailySourceEnabled = false,
    threeMonthPairSourceEnabled = false,
    statisticsEnabled = false,
    anomalyCountEnabled = false,
    peakReductionRateEnabled = false,
  } = options || {};

  const {
    dailyTrio,
    dailyTrioLoadType,
    hourly,
    hourlyLoadType,
    dailySingleLoadType,
    dailyTimeLoadType,
    daily,
    fifteenMinutes,
    dailyPair,
    dailySingle,
    currentLoadType,

    dailyTrioLoading,
    dailyTrioLoadTypeLoading,
    hourlyLoading,
    hourlyLoadTypeLoading,
    dailySingleLoadTypeLoading,
    dailyTimeLoadTypeLoading,
    dailyLoading,
    fifteenMinutesLoading,
    dailyPairLoading,
    dailySingleLoading,
  } = useDailyHourQuery(
    {
      dailyTrioEnabled,
      dailyTrioLoadTypeEnabled,
      hourlyEnabled,
      hourlyLoadTypeEnabled,
      dailySingleLoadTypeEnabled,
      dailyTimeLoadTypeEnabled,
      dailyEnabled,
      fifteenMinuteEnabled,
      dailyPairEnabled,
      dailySingleEnabled,
    },
    selectedDate,
    equipment,
  );
  const {
    monthlyTrio,
    monthlyTrioLoadType,
    monthlySingle,
    monthly,
    previousMonthly,
    monthlyPair,
    monthlyEquipment,
    monthlyBilling,
    compareData,
    compareMaxPower,
    compareTotalEnergy,

    monthlyTrioLoading,
    monthlyTrioLoadTypeLoading,
    monthlySingleLoading,
    monthlyLoading,
    previousMonthlyLoading,
    monthlyPairLoading,
    monthlyEquipmentLoading,
    monthlyBillingLoading,
    compareLoading,
    compareMaxPowerLoading,
    compareTotalEnergyLoading,
  } = useMonthlyQuery(
    {
      monthlyTrioEnabled,
      monthlyTrioLoadTypeEnabled,
      monthlySingleEnabled,
      monthlyEnabled,
      previousMonthlyEnabled,
      monthlyPairEnabled,
      monthlyEquipmentEnabled,
      monthlyBillingEnabled,
      compareTotalEnabled,
      compareTariffEnabled,
      compareMaxPowerEnabled,
    },
    selectedDate,
    equipment,
    planName,
  );
  const {
    yearlyTrio,
    yearlyTrioLoadType,
    yearlyPair,
    yearLoadType,
    yearSingle,
    usageAgaunst,

    yearlyTrioLoading,
    yearlyTrioLoadTypeLoading,
    yearlyPairLoading,
    yearLoadTypeLoading,
    yearSingleLoading,
    usageAgaunstLoading,
  } = useYearlyQuery(
    {
      yearlyTrioEnabled,
      yearlyTrioLoadTypeEnabled,
      yearlyPairEnabled,
      yearLoadTypeEnabled,
      yearSingleEnabled,
      usageAgaunstEnabled,
    },
    selectedDate,
    equipment,
  );

  const {
    dailySource,
    threeMonthPairSource,
    statisticsData,
    anomalyCountData,
    peakReductionRateData,
    isLoadingThreeMonthPairSource,
    isLoadingStatisticsData,
  } = useCertificationQuery(
    {
      predictionAccuracyEnabled,
      certificationEnabled,
      dailySourceEnabled,
      threeMonthPairSourceEnabled,
      statisticsEnabled,
      anomalyCountEnabled,
      peakReductionRateEnabled,
    },
    selectedDate,
    selectedMonth,
  );

  const mapData = (mappingFn: any, dataMap: any) => {
    return Object.fromEntries(
      Object.entries(dataMap)?.map(([key, data]) => [key, mappingFn(data)]),
    );
  };

  return {
    dailySource,
    threeMonthPairSource,
    statisticsData,
    peakReductionRateData,
    totalEnergy: mapData(mapTotalEnergy, {
      daily: daily?.data, // 일별 소비전력량
      dailySingleLoadType: dailySingleLoadType?.data, // 시간별 부하별 소비전력량
      dailyTrio: dailyTrio?.data, // 일간소비전력량
      dailyTrioLoadType: dailyTrioLoadType?.data, // 일별 부하별 소비전력량
      yearlyTrio: yearlyTrio?.data, // 연간소비전력량
      yearlyTrioLoadType: yearlyTrioLoadType?.data, // 연간 부하별 소비전력량
      monthly: monthly?.data, // 연간 소비전력량
      previousMonthly: previousMonthly?.data, // 전년도 소비전력량
      monthlySingle: monthlySingle?.data, // 월간 단일 소비전력량
      monthlyPair: monthlyPair?.data,
      monthlyTrio: monthlyTrio?.data, // 월간소비전력량
      monthlyTrioLoadType: monthlyTrioLoadType?.data, // 월간 부하별 소비전력량
      hourly: hourly?.data, // 시간별 소비전력량
      hourlyLoadType: hourlyLoadType?.data, // Grid 시간별 부하별 소비전력량
      yearlySingle: yearSingle?.data, // 연간 단일 소비전력량
    }),

    range: mapData(mapRangeData, {
      dailyPair: dailyPair?.data, // 일별 소비전력량
      monthlyPair: monthlyPair?.data, // 월별 소비전력량
    }),

    loadType: mapData(mapLoadTypeData, {
      dailyTrioLoadType: dailyTrioLoadType?.data, // 일별 부하별 소비전력 금액
      hourlyLoadType: hourlyLoadType?.data, // 시간별 부하별 소비전력량
    }),

    cost: mapData(mapCost, {
      hourly: hourly?.data, // 시간별 소비전력 금액
      dailyTrioLoadType: dailyTrioLoadType?.data, // 금일 소비전력 금액
      monthlyTrioLoadType: monthlyTrioLoadType?.data, // 금월 소비전력 금액
      yearlyTrioLoadType: yearlyTrioLoadType?.data, // 금년 소비전력 금액
      dailySingleLoadType: dailySingleLoadType?.data, // 시간별 부하별 소비전력 금액
      monthlySingle: monthlySingle?.data, // 월간 단일 소비전력 금액
      hourlyLoadType: hourlyLoadType?.data, // Grid 시간별 부하별 소비전력 금액
    }),

    maxPower: mapData(mapMaxPower, {
      hourly: hourly?.data, // 시간별 소비 최대전력
      hourlyLoadType: hourlyLoadType?.data, // Grid 시간별 부하별 소비 최대전력
      dailySingleLoadType: dailySingleLoadType?.data, // 시간별 부하별 소비 최대전력
      dailySingle: dailySingle?.data, // 일별 소비 최대전력
      monthlyTrioLoadType: monthlyTrioLoadType?.data, // 월간 부하별 소비 최대전력
      monthlySingle: monthlySingle?.data, // 월간 단일 소비 최대전력
      yearlyTrioLoadType: yearlyTrioLoadType?.data, // 연간 부하별 소비 최대전력
      yearlySingle: yearSingle?.data, // 연간 소비 최대전력
    }),

    daily: mapData(mapDailyData, {
      daily: daily?.data, // 일별 소비 최대전력
    }),

    quarterMaxPower: mapData(mapQuarterMaxPower, {
      fifteenMinutes: fifteenMinutes?.data, // 15분별 소비 최대전력
    }),

    carbon: mapData(mapCarbonEmission, {
      dailyTrio: dailyTrio?.data, // 일간탄소배출량Trio
      monthlyTrio: monthlyTrio?.data, // 월간탄소배출량Trio
      yearlyTrio: yearlyTrio?.data, // 연간탄소배출량Trio
      hourly: hourly?.data, // 시간별 탄소배출량
      daily: daily?.data, // 일별 탄소배출량
      monthly: monthly?.data, // 월별 탄소배출량
      yearlySingle: yearSingle?.data, // 연간 단일 탄소배출량
    }),
    toe: mapData(mapToe, {
      yearlyTrio: yearlyTrio?.data, // 연간 toe
    }),
    loadTypeDayCost: mapData(mapLoadTypeDayCostData, {
      dailyTimeLoadType: dailyTimeLoadType?.data, // 일별 부하별 금액
    }),
    loadTypeDayData: mapData(mapLoadTypeDayConsumptionMaxPowerCostData, {
      dailyTimeLoadType: dailyTimeLoadType?.data, // 일별 부하별 소비전력 및 최대전력 및 금액,
      yearLoadType: yearLoadType?.data, // 연간 부하별 소비전력 및 최대전력 및 금액
    }),

    quarterHourly: mapData(mapQuarterHourly, {
      fifteenMinutes: fifteenMinutes?.data, // 15분별 data
    }),

    yearCostEnergy: mapData(mapYearCostTotalEnergy, {
      yearlyPair: yearlyPair?.data, // 연간 소비전력량 및 금액
    }),

    target: mapData(targetData, {
      usageAgaunst: usageAgaunst?.data, // 사용량 대비
    }),
    equipment: mapData(equipmentData, {
      monthlyEquipment: monthlyEquipment?.data, // 월간 설비
    }),

    bill: mapData(mapBillingData, {
      monthly: monthlyBilling?.data, // 월별 청구요금
    }),

    compareMaxPower: mapData(mapCompareVariableData, {
      compareMaxPower: compareMaxPower?.data, // 요금제 비교 - 최대전력가변
    }),
    compareTotalEnergy: mapData(mapCompareTotalEnergyData, {
      compareTotalEnergy: compareTotalEnergy?.data, // 요금제 비교 - 전력량가변
    }),
    compareTariffPlan: mapCompareData(compareData),
    currentLoadType, // 현재 부하
    anomaly: mapAnomalyCountData(anomalyCountData?.data),

    loadingState: {
      dailyTrioLoading,
      dailyTrioLoadTypeLoading,
      hourlyLoading,
      hourlyLoadTypeLoading,
      dailySingleLoadTypeLoading,
      dailyTimeLoadTypeLoading,
      dailyLoading,
      monthlyTrioLoading,
      monthlyTrioLoadTypeLoading,
      monthlySingleLoading,
      monthlyLoading,
      yearlyTrioLoading,
      yearlyTrioLoadTypeLoading,
      yearlyPairLoading,
      previousMonthlyLoading,
      yearLoadTypeLoading,
      fifteenMinutesLoading,
      dailyPairLoading,
      monthlyPairLoading,
      dailySingleLoading,
      yearSingleLoading,
      usageAgaunstLoading,
      monthlyEquipmentLoading,
      monthlyBillingLoading,
      compareLoading,
      compareMaxPowerLoading,
      compareTotalEnergyLoading,
      isLoadingThreeMonthPairSource,
      isLoadingStatisticsData,
    },
  };
};
